import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import parse from "html-react-parser";

export default function SlideSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div {...useBlockProps.save()}>
      <div className="content pe-4">
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
